<template>
  <div class="menu-item" @click="onClick">
    <div
      class="menu-layout"
      :style="{
        background:
          backgroundType == 2 ? `url(${backgroundPicUrl})` : backgroundCode,
        'background-size': 'cover',
        'background-repeat': 'no-repeat'
      }"
    >
      <img class="menu-item-img" :src="backgroundIconUrl" />
      <p class="menu-item-title">{{ title }}</p>
    </div>
  </div>
</template>
<script>
import { Dialog } from "vant";
const routerConfig = {
  "1": { path: "/exhibition", param: "id" },
  "3": { path: "/conference/registered", param: "code" },
  "4": { path: "/conference/register", param: "code" },
  "2": { path: "/livehome", param: "project" }
};

export default {
  name: "MenuItem",
  props: {
    pageType: {
      type: Number,
      default: 0
    },
    signflag: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ""
    },
    backgroundType: {
      type: Number,
      default: 0
    },
    backgroundCode: {
      type: String,
      default: ""
    },
    backgroundPicUrl: {
      type: String,
      default: ""
    },
    liveJumpUrl: {
      type: String,
      default: ""
    },
    signStatus: {
      type: Number,
      default: 0
    },

    backgroundIconUrl: {
      type: String,
      default: ""
    },
    v: {
      type: String,
      default: ""
    }
  },
  methods: {
    onClick() {
      console.info(this.pageType);
      console.info(this.v);
      if (this.pageType == 1) {
        this.$router.push({
          path: "/conference/showImg",
          query: {
            url: this.v,
            code: this.$route.query.code,
            title: this.title
          }
        });
      } else if (this.pageType == 2) {
        window.open(this.v);
      } else if (this.pageType == 3) {
        const urlConfig = routerConfig[this.v];
        if (urlConfig.param) {
          if (this.v == 2 && this.signflag == 1 && this.signStatus != 1) {
            return Dialog.alert({
              title: "温馨提示",
              message: "您还没有报名，请点击确定注册"
            }).then(() => {
              this.$router.push({
                path: "/conference/registered",
                query: { code: this.$route.query.code, isConference: 1 }
              });
            });
          }
          if (this.v == 2 && this.liveJumpUrl && this.signStatus == 1) {
            window.location.href = this.liveJumpUrl;
            return;
          }
          this.$router.push({
            path: urlConfig.path,
            query: {
              [urlConfig.param]: this.$route.query.code,
              isConference: 1 // 判断是会议
            }
          });
        } else {
          this.$router.push({
            path: urlConfig.path
          });
        }
      }
    }
  }
};
</script>
<style scoped>
.menu-item {
  margin-top: 0;
  margin-bottom: 0;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
  height: 113px;
  padding: 0 5px;
  margin-bottom: 10px;
  display: block;
}
.menu-layout {
  width: 100%;
  height: 100%;
  display: flex;

  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.menu-item .menu-item-img {
  width: 43px;
  height: 43px;
}
.menu-item .menu-item-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
  margin-top: 8px;
  color: #fff;
}
</style>
